export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const facebook =
  'https://d24rddnpxh8ji7.cloudfront.net/facebookWhite.png'
export const instagram =
  'https://d24rddnpxh8ji7.cloudfront.net/instagramWhite.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1653013257/cozen/menuButton.png'
export const cflogo = 'https://d24rddnpxh8ji7.cloudfront.net/cflogo.png'
export const about =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/about2.webp'
export const aboutParallax =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1620855562/chosun/aboutParallax.jpg'
export const contactbg =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/contactbg.webp'
export const foodGallery =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/gallery.webp'
export const hero = 'https://d24rddnpxh8ji7.cloudfront.net/sushigio/heroBg.webp'
export const heroText =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/heroText.webp'
export const logo = 'https://d24rddnpxh8ji7.cloudfront.net/sushigio/logo.webp'
export const locationMap =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/map3.webp'
export const mobileAbout =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/mobileAbout2.webp'
export const mobileContactbg =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/mobileContact.webp'
export const mobileGallery =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/mobileGallery3.webp'
export const mobileHero =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/mobileHero2.webp'
export const mobileLogo =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/mobileLogo.webp'
export const mobileMap =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/mobileMap3.webp'
export const mobileHeroText =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/mobileHeroText.webp'
export const mobilePromotion =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/mobilePromo.webp'
export const orderPickupButton =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/OrderPickupButton.webp'
export const promotions =
  'https://d24rddnpxh8ji7.cloudfront.net/sushigio/promo.webp'

export { default as menu } from './cozenMenu.pdf'
